
<div *ngFor="let data of rows">
    <div *ngIf="data.show">
    <h2>{{data.fileName}}</h2>
  
        <table>
            <thead>
                <th *ngFor="let keyName of columnTitles">
                    {{keyName}}
                </th>
            </thead>
            <tbody>
                <tr (click)="openPdf(row.page)" *ngFor="let row of data.lines">
                    <td *ngFor="let keyName of columnTitles">
                        {{row[keyName]}}
                    </td>
                </tr>
            </tbody>
        </table>
        
</div>